module.exports = __webpack_public_path__ + "static/media/Help.5e98c42a.svg";